module.exports = __webpack_public_path__ + "static/audio_vultures-8a02b4aed54b370af3c2fddfb943e092.mp4";